<div class="app-footer">
    <div class="footer">
        <p class="upper">@2018 Pricing Tags</p>
        <p>Społem "TEST"</p>
        <u class="upper" style="text-decoration: underline;">centrum pomocy</u>
    </div>
</div>

<style>
    .app-footer {
        background: rgb(80,81,82);
        color: white;
    }

    .app-footer .footer {
        display: flex;
        width: 90%;
        margin: 0 auto;
        padding: .8em 0;
        justify-content: space-between;
        font-size: 13px;
    }
</style>